import React from "react";
import styled from "styled-components";

const ComunidadSelectorModal = ({
  isOpen,
  onClose,
  comunidades,
  selectedComunidadId,
  onSelectComunidad,
  onSave,
}) => {
  React.useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <ModalBody>
        <CloseBtn onClick={onClose}>✕</CloseBtn>
        <Title>SELECCIONAR COMUNIDAD</Title>
        <ComunidadGrid>
          {comunidades.map((com) => (
            <ComunidadTile
              key={com.id}
              $selected={com.id === selectedComunidadId}
              onClick={() => onSelectComunidad(com.id)}
            >
              <FlagImage src={com.flagUrl} alt={com.name} style={com.id === "valencia" ? { objectPosition: "15% center" } : {}} />
              <ComunidadName>{com.name}</ComunidadName>
            </ComunidadTile>
          ))}
        </ComunidadGrid>
        <SaveBtn onClick={onSave}>GUARDAR</SaveBtn>
      </ModalBody>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
`;

const ModalBody = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 2rem;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: var(--v-fg-muted);
  font-size: 16px;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;

const Title = styled.h3`
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-fg-muted);
  margin: 0 0 1.5rem;
  text-align: center;
`;

const ComunidadGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`;

const ComunidadTile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 0.5rem;
  border: 1px solid ${({ $selected }) =>
    $selected ? "var(--v-mint)" : "rgba(255,255,255,0.06)"};
  border-radius: 16px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: var(--v-mint);
    background: rgba(60, 255, 208, 0.03);
  }
`;

const FlagImage = styled.img`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  object-fit: cover;
`;

const ComunidadName = styled.span`
  font-family: var(--v-font-mono);
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: var(--v-fg);
  text-align: center;
  line-height: 1.2;
`;

const SaveBtn = styled.button`
  display: block;
  margin: 0 auto;
  background: var(--v-mint);
  border: none;
  color: #000;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.6rem 2rem;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.85;
  }
`;

export default ComunidadSelectorModal;
